import { produce } from 'immer';
import _, { initial } from 'lodash';
import { combineReducers } from 'redux';
import { conf, Relationship, Resource, Schema, RelType } from 'src/config';
import { ApplicationState, AppPhase, PhaseStatus, ApplicationActions } from './types';
import * as constants from './constants';
import moment, { Moment } from 'moment'

const initialState: ApplicationState = {
    application: null,
    optimisticStart: null,
    phases: {
        [AppPhase.Fetch]: { timedout: false },
        [AppPhase.Create]: { timedout: false },
        [AppPhase.Compile]: { timedout: false },
        [AppPhase.Init]: { timedout: false },
        [AppPhase.Backend]: { timedout: false },
        [AppPhase.Start]: { timedout: false },
        [AppPhase.Ping]: { timedout: false },
        [AppPhase.Stop]: { timedout: false },
        [AppPhase.Destroy]: { timedout: false },
    },
    isFetching: false,
    isPinging: false,
    lastPinged: null,
    pingTimedOut: false,
    heartbeatFail: false,
    // isBuilding: false,
    interrupt: true,
}

const appReducer = (
    state = initialState,
    action: ApplicationActions
) => {
    return produce(state, draft => {
        if (action.type === constants.START_FETCH_APP) {
            draft.isFetching = true
            draft.interrupt = false
        } else if (action.type === constants.SUCCESS_FETCH_APP) {
            draft.isFetching = false;
            draft.application = action.application;
            draft.optimisticStart = null;
            draft.lastPinged = null;
        } else if (action.type === constants.START_CREATE) {

        } if (action.type === constants.START_DESTROY) {

        } else if (action.type === constants.START_COMPILE) {

        } else if (action.type === constants.START_INIT) {

        } else if (action.type === constants.START_BUILD_BACKEND) {

        } else if (action.type === constants.START_START) {

        } else if (action.type === constants.START_STOP) {

        } else if (action.type === constants.START_BUILD) {
            // draft.isBuilding = true;
        }
        // else if (action.type === constants.END_BUILD) {
            // draft.isBuilding = false;
        // } 
        else if (action.type === constants.SET_PHASE_STATUS) {
            const { phase, status } = action;
            draft.phases[phase] = status;
        } else if (action.type === constants.START_PINGING) {
            console.log('Reducer: START_PINGING');
        } else if (action.type === constants.DO_START_PINGING) {
            draft.lastPinged = null
            draft.pingTimedOut = false
            draft.isPinging = true
        } else if (action.type === constants.SUCCESS_PING) {
            draft.lastPinged = moment()
            draft.pingTimedOut = false
            draft.isPinging = false
            draft.phases[AppPhase.Ping] = { timedout: false }
        } else if (action.type === constants.FAIL_PING) {
            draft.lastPinged = null
        } else if (action.type === constants.PINGING_TIMEOUT) {
            draft.lastPinged = null
            draft.pingTimedOut = true
            draft.isPinging = false
            draft.phases[AppPhase.Ping] = { timedout: true }
        } else if (action.type === constants.HEARTBEAT_START) {
            draft.isPinging = true
            draft.heartbeatFail = false
        } else if (action.type === constants.HEARTBEAT_SUCCESS) {
            draft.lastPinged = moment()
        } else if (action.type === constants.HEARTBEAT_FAILURE) {
            draft.isPinging = false
            draft.heartbeatFail = true
        } else if (action.type === constants.HEARTBEAT_STOP) {
            draft.isPinging = false
        } else if (action.type === constants.OPTIMISTIC_START) {
            const { milestone, timestamp } = action;
            draft.optimisticStart = {
                milestone,
                timestamp
            }
        } else if (action.type === constants.RESET) {
            const initial = _.cloneDeep(initialState);

            draft.application = initial.application;
            draft.phases = initial.phases;
            draft.heartbeatFail = initial.heartbeatFail;
            draft.isFetching = initial.isFetching;
            draft.isPinging = initial.isPinging;
            draft.lastPinged = initial.lastPinged;
            draft.optimisticStart = initial.optimisticStart;
            draft.pingTimedOut = initial.pingTimedOut;
            // draft.isBuilding = initial.isBuilding;
            draft.interrupt = initial.interrupt;

        }
    });
};

const reducer = combineReducers({
    application: appReducer,
});

export default reducer;